'use client'

import { Clipboard } from '@/components/common/Clipboard'
import { useReduxSelector } from '@/store/hooks'

import { MenuCommonRoot } from '../MenuCommon/MenuCommonRoot/MenuCommonRoot'

export const MenuClipboard = () => {
  const isOpen = useReduxSelector((s) => s.view.mobileStatus === 'clipboard')

  return (
    <MenuCommonRoot isOpen={isOpen} placement='right' variant='clipboard'>
      {isOpen && <Clipboard isOpen={isOpen} />}
    </MenuCommonRoot>
  )
}
